var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeClubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4386",
    "data-name": "Group 4386",
    transform: "translate(-11286.525 10409.846)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21043",
    "data-name": "Ellipse 21043",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(11286.525 -10409.846)",
    fill: "#74b1ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "golf-club-variant-in-diagonal-position",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 11293.599, -10406.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M8.914.522,7.581,2.656a.34.34,0,0,1-.193.146L3.112,9.972l-.543.808s-1.43.464-2.09-.2c-.7-.7-.821-2.074.955-1.441l.084.031a8.651,8.651,0,0,1,1.126.588L6.955,2.524A.338.338,0,0,1,7,2.294L8.335.16a.341.341,0,1,1,.579.362Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "golf-club-variant-in-diagonal-position-2",
    "data-name": "golf-club-variant-in-diagonal-position",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 11290.749, -10404.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1873-2",
    "data-name": "Path 1873",
    d: "M.052.522,1.385,2.656a.34.34,0,0,0,.193.146l4.277,7.17.543.808s1.43.464,2.09-.2c.7-.7.821-2.074-.955-1.441l-.084.031a8.651,8.651,0,0,0-1.126.588L2.011,2.524a.338.338,0,0,0-.047-.23L.631.161A.341.341,0,1,0,.052.522Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeClubIcon);
export default __webpack_public_path__ + "static/media/home_club_icon.460e008ececdfc4d911af8a729df30a8.svg";
export { ForwardRef as ReactComponent };